require('./nbf/nbf.js');
require('./nbf/nbf/config.js');
require('./nbf/nbf/selector.js');
require('./nbf/nbf/str.js');
require('./nbf/nbf/url.js');
require('./nbf/ui.js');
require('./nbf/ui/listado.js');
require('./nbf/ui/selector.js');
require('./nbf/ui/form.js');
require('./nbf/ui/toolbar.js');
require('./nbf/ui/popup.js');
require('./nbf/css/actualizar.js');
require('./nbf/css/Clase.js');
require('./nbf/vista/Tag.js');
require('./nbf/vista/Vista.js');

window.jQuery = jQuery // Para plugins que se cargan dinámicamente con nbf.cargarJs como jquery ui